import React, { useState } from "react";
import "./Vaccination_record.css";
import Upcoming from "./Upcoming";
import Missed from "./Missed";
import Completed from "./Completed";
import Accordion from "react-bootstrap/Accordion";
import { Vaccination_img } from "assets/icons";

const Vaccination_record = ({ _child }) => {
  const [propertyTab, setPropertyTab] = useState("Upcoming");

  return (
    <>
      <div className="Vaccination_record_parent">
        <div className="vaccination_record_wraper">
          <div className="wrapper_cstm_tabers">
            <ul>
              <li
                className={propertyTab === "Upcoming" ? "active" : ""}
                onClick={() => setPropertyTab("Upcoming")}
              >
                Upcoming
              </li>

              <li
                className={propertyTab === "Missed" ? "active" : ""}
                onClick={() => setPropertyTab("Missed")}
              >
                Missed
              </li>

              <li
                className={propertyTab === "Completed" ? "active" : ""}
                onClick={() => setPropertyTab("Completed")}
              >
                Completed
              </li>
            </ul>
          </div>

          <Upcoming _child={_child} status={propertyTab.toUpperCase()} />

          {/* {propertyTab === "Upcoming" && <Upcoming _child={_child} status={propertyTab.toUpperCase()} />} */}
          {/* {propertyTab === "Missed" && <Missed />}
          {propertyTab === "Completed" && <Completed />} */}
        </div>

      </div>
    </>
  );
};

export default Vaccination_record;
